function NewsLettersPage(){

    return (
        <>
            <div className="Layout_childrenDiv__uf2y3">
  <div className="Layout_mainCookieDiv__7nVqL">
    <div className="Layout_componentCookieDiv__jDU_3" />
  </div>
  <div>
    <div>
      <div className="Search_mainDiv__dykhV">
        <div className="Search_componentDiv__D58MC">
          <div className="Search_titleDiv__zVk8s">
            <h1>Newsletters</h1>
          </div>
          <div className="Search_subscribeDiv__W_Niz">
            <div className="Subscribe_mainDiv__fuWwt">
              <div className="Subscribe_componentDiv__ZKJex">
                <div className="Subscribe_leftDiv__AWW59">
                  <img
                    alt="Coin Bureau Newsletter"
                    loading="lazy"
                    width={46}
                    height={46}
                    decoding="async"
                    data-nimg={1}
                    src="/letter.svg"
                    style={{ color: "transparent", maxWidth: "100%" }}
                  />
                </div>
                <div className="Subscribe_subtitleDiv__lXfkT">
                  Subscribe to our newsletter. Receive new articles and
                  resources directly on your inbox.
                </div>
                <div className="Subscribe_subscribeBox__yDsjy">
                  <div className="Subscribe_subscribeBoxContainer__56dnC">
                    <div className="Subscribe_emailBox__t85zH">
                      <input
                        className="Subscribe_emailInput__VVYh_"
                        type="text"
                        placeholder="Enter your email"
                        name="email"
                        defaultValue=""
                      />
                    </div>
                    <div
                      className="Subscribe_submitBtn__t_O9A"
                      id="newsletter_main_sign_up"
                    >
                      Subscribe
                    </div>
                  </div>
                  <div style={{ height: 10 }} />
                </div>
              </div>
            </div>
          </div>
          <div className="Search_searchDiv__wg6lD">
            <div className="Search_leftDiv__WKCil">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth={0}
                version="1.1"
                id="search"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                className="Search_searchIcon__pwZvP"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path
                    d="M20.031,20.79c0.46,0.46,1.17-0.25,0.71-0.7l-3.75-3.76c1.27-1.41,2.04-3.27,2.04-5.31
		c0-4.39-3.57-7.96-7.96-7.96s-7.96,3.57-7.96,7.96c0,4.39,3.57,7.96,7.96,7.96c1.98,0,3.81-0.73,5.21-1.94L20.031,20.79z
		 M4.11,11.02c0-3.84,3.13-6.96,6.96-6.96c3.84,0,6.96,3.12,6.96,6.96c0,3.84-3.12,6.96-6.96,6.96C7.24,17.98,4.11,14.86,4.11,11.02
		z"
                  />
                </g>
              </svg>
              <input type="text" placeholder="Search" defaultValue="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div className="Newsletter_mainDiv__5dFa1">
        <div className="Newsletter_componentDiv__jvY7q">
          <div className="Newsletter_cardDiv__bYJNh">
            <a href="/newsletters/china-crypto/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="China Could Change Crypto FOREVER!"
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FChina_Crypto_Update_2ced6b2a43.jpg&w=828&q=25 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FChina_Crypto_Update_2ced6b2a43.jpg&w=1920&q=25 2x"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FChina_Crypto_Update_2ced6b2a43.jpg&w=1920&q=25"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                      />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      China Could Change Crypto FOREVER!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      We examine China’s fraught relationship with crypto and
                      how it could change under Trump. And we cover more on
                      DeFAI.
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Jan 20, 2025</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/russia-bitcoin/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Russia is Diving Into Bitcoin! What it Means"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FRussia_update_2e080c7ca5.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FRussia_update_2e080c7ca5.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FRussia_update_2e080c7ca5.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Russia is Diving Into Bitcoin! What it Means
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      In this week's newsletters, we examine how Russia is
                      adopting Bitcoin for use in cross-border trade, and what
                      the heck's DeFAI?
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Jan 14, 2025</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/crypto-mistakes-to-avoid/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="These Mistakes Could Cost You MILLIONS!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FBull_Market_Mistakes_3d7ea2e388.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FBull_Market_Mistakes_3d7ea2e388.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FBull_Market_Mistakes_3d7ea2e388.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      These Mistakes Could Cost You MILLIONS!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      The 10 biggest crypto mistakes to avoid, the usual crypto
                      market forecast and AI agents - all that and more in this
                      week's newsletter.
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Jan 06, 2025</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/2025-crypto-predictions/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Our 2025 Predictions: Don’t Miss This!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2F2025_Predictions_44e50b2e98.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2F2025_Predictions_44e50b2e98.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2F2025_Predictions_44e50b2e98.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Our 2025 Predictions: Don’t Miss This!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      What does 2025 have in store for the crypto market?
                      Spoiler alert: we think it’s going to be a BIG year.
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Dec 30, 2024</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/coin-bureau-portfolio/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Coin Bureau Portfolio Updates Revealed!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fcoinbureau_portfolio_3f876b080a.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fcoinbureau_portfolio_3f876b080a.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fcoinbureau_portfolio_3f876b080a.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Coin Bureau Portfolio Updates Revealed!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      What cryptocurrencies do The Coin Bureau's creme de la
                      creme hold? Guy and Nic reveal their top holdings! That,
                      and our 2024 predictions
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Dec 16, 2024</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/crypto-secrets-revealed/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Crypto Secrets Revealed: Why 75% Fail!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FCoinfessions_Survey_81682ad4aa.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FCoinfessions_Survey_81682ad4aa.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FCoinfessions_Survey_81682ad4aa.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Crypto Secrets Revealed: Why 75% Fail!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      In this week's newsletter, we look into a report that
                      reveals some shocking facts and stats about the state of
                      crypto market participants. And, Jurrasic rally!
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Dec 10, 2024</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/bitcoin-price-prediction/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Bitcoin Price Prediction Revealed!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fbitcoin_price_prediction1_f290c45027.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fbitcoin_price_prediction1_f290c45027.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fbitcoin_price_prediction1_f290c45027.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Bitcoin Price Prediction Revealed!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      In this week's newsletter: A look at recent BTC price
                      predictions, crypto market forecast and AI agent recap.
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Dec 02, 2024</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/top-tips-for-earning-crypto/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Top Tips For Earning Crypto Revealed!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fcrypto_passive_income_77a690c07a.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fcrypto_passive_income_77a690c07a.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2Fcrypto_passive_income_77a690c07a.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Top Tips For Earning Crypto Revealed!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      In this week's newsletter, using crypto to earn crypto,
                      the usual crypto market forecast and GameFi alpha from the
                      YGG Play Summit.
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Nov 25, 2024</div>
                </div>
              </div>
            </a>
            <a href="/newsletters/trump-tarrifs/">
              <div className="Newsletter_singleCard__TOWPO">
                <div className="Newsletter_upperDiv__8JPJU">
                  <div className="Newsletter_thumbnailDiv__HsZDx">
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "inline-block",
                        overflow: "hidden",
                        width: "initial",
                        height: "initial",
                        background: "none",
                        opacity: 1,
                        border: 0,
                        margin: 0,
                        padding: 0,
                        position: "relative",
                        maxWidth: "100%"
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          display: "block",
                          width: "initial",
                          height: "initial",
                          background: "none",
                          opacity: 1,
                          border: 0,
                          margin: 0,
                          padding: 0,
                          maxWidth: "100%"
                        }}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27768%27%20height=%27432%27/%3e"
                          style={{
                            display: "block",
                            maxWidth: "100%",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0
                          }}
                        />
                      </span>
                      <img
                        alt="Trump Tariffs Are Coming!"
                        src="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FTrump_s_plan_to_reintroduce_aggressive_tariffs_8036c93691.jpg&w=1920&q=50"
                        decoding="async"
                        data-nimg="intrinsic"
                        className="Newsletter_image__TekdI"
                        style={{
                          position: "absolute",
                          inset: 0,
                          boxSizing: "border-box",
                          padding: 0,
                          border: "none",
                          margin: "auto",
                          display: "block",
                          width: 0,
                          height: 0,
                          minWidth: "100%",
                          maxWidth: "100%",
                          minHeight: "100%",
                          maxHeight: "100%",
                          objectFit: "cover"
                        }}
                        srcSet="/_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FTrump_s_plan_to_reintroduce_aggressive_tariffs_8036c93691.jpg&w=828&q=50 1x, /_next/image/?url=https%3A%2F%2Fimage.coinbureau.com%2Fstrapi%2FTrump_s_plan_to_reintroduce_aggressive_tariffs_8036c93691.jpg&w=1920&q=50 2x"
                      />
                      <noscript />
                    </span>
                  </div>
                  <div className="Newsletter_detailsDiv__ycQ50">
                    <div className="Newsletter_titleDiv__IB0Ev">
                      Trump Tariffs Are Coming!
                    </div>
                    <div className="Newsletter_descriptionDiv__e6aVx">
                      In this week's newsletter, we examine Trump’s tariff
                      fixation and bringing you up to speed on the origin/lore
                      of the main memecoins that led the rally.
                    </div>
                  </div>
                </div>
                <div className="Newsletter_lowerDiv__FDcvR">
                  <div className="Newsletter_dateDiv__pr8zc">Nov 18, 2024</div>
                </div>
              </div>
            </a>
          </div>
          <div className="Newsletter_pagination__iZEJK">
            <div className="Newsletter_arrowDisabled___1Mpv">&lt;</div>
            <div className="Newsletter_hide__QCRv1">
              <span>17</span>
            </div>
            <div className="Newsletter_hide__QCRv1">
              <span>18</span>
            </div>
            <div className="Newsletter_hide__QCRv1">
              <span>-1</span>
            </div>
            <div className="Newsletter_hide__QCRv1">
              <span>0</span>
            </div>
            <div>
              <span className="Newsletter_active__ottbo">1</span>
            </div>
            <div className="Newsletter_show__QdaEn">
              <span>2</span>
            </div>
            <div className="Newsletter_show__QdaEn">
              <span>3</span>
            </div>
            <div className="Newsletter_dots__QPtZp">...</div>
            <div className="Newsletter_show__QdaEn">
              <span>21</span>
            </div>
            <div className="Newsletter_arrow__PvXcu">
              <span>&gt;</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="NewslettersB_fixedSubscribeCardDiv__RxAgE">
      <div className="FixedSubscribeCard_mainDiv__zezjV">
        <div className="FixedSubscribeCard_componentDiv__bpSZ3">
          <div className="FixedSubscribeCard_leftDiv__q_rn9">
            <div className="FixedSubscribeCard_headerDiv__RdUVB">
              <div className="FixedSubscribeCard_titleDiv__BP4tI">
                Free Crypto Coverage Direct to Your Inbox
              </div>
              <div className="FixedSubscribeCard_icon__KX3uM">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth={0}
                  viewBox="0 0 512 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" />
                </svg>
              </div>
            </div>
            <div className="FixedSubscribeCard_subscribeBox__HlT_f">
              <div className="FixedSubscribeCard_emailBox__yD1wc">
                <input
                  className="FixedSubscribeCard_emailInput__JvyUg"
                  type="text"
                  placeholder="Enter your email"
                  name="email"
                  defaultValue=""
                />
              </div>
              <div
                className="FixedSubscribeCard_submitBtn__CL7jL"
                id="newsletter_main_sign_up"
              >
                Subscribe
              </div>
            </div>
            <div style={{ height: 20 }} />
          </div>
        </div>
      </div>
    </div>
  </div>
            </div>
        </>
    )
}

export default NewsLettersPage;